module.exports = __webpack_public_path__ + "img/position_pro_img1.064dc503.png";